import { render, staticRenderFns } from "./StavL_Search.vue?vue&type=template&id=cc0bbc46"
import script from "./StavL_Search.vue?vue&type=script&lang=js"
export * from "./StavL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports